import React from 'react';
import "./App.css";
import { useLocation } from 'react-router-dom';
import AuthLayout from './layout/AuthLayout/AuthLayout.jsx';
import MainLayout from './layout/MainLayout/MainLayout.jsx';
import { Provider } from 'react-redux';
import store from './Redux/store.js';

const App = () => {
    const location = useLocation();

    return (
        <Provider store={store}>
            {location.pathname.includes("/auth/") ? (
                <AuthLayout />
            ) : (
                <MainLayout />
            )}
        </Provider>
    );
}

export default App;